import { globby } from 'globby';
import { join } from 'node:path';

export async function loadFiles(cwd: string) {
  return globby('**/*', { cwd, onlyFiles: true }).then((files) =>
    files.map((relativePath) => {
      return {
        path: join(cwd, relativePath),
        relativePath,
      };
    })
  );
}

export async function loadDeployableFiles(cwd: string) {
  return globby('**/*', {
    cwd,
    onlyFiles: true,
    gitignore: true,
    dot: false,
    followSymbolicLinks: false,
    ignore: [
      // https://vercel.com/docs/builds/build-features
      // https://github.com/netlify/cli/blob/8a07280b83de35aae6dee80212d4e065147e3456/src/utils/deploy/upload-source-zip.ts#L23C7-L23C30
      '**/*.log',
      '**/CVS',
      '**/Thumbs.db',
      '**/__pycache__',
      '**/__pycache__*',
      '**/build*',
      '**/config.gypi',
      '**/coverage*',
      '**/dist*',
      '**/node_modules',
      '**/node_modules*',
      '**/npm-debug.log',
      '**/venv',
      // lock files
      '**/package-lock.json',
      '**/*.lock',
      '**/pnpm-lock.yaml',
      '**/bun.lockb',
      // custom defined paths
      '**/package.json',
      '**/wix.config.json',
      '**/wix-error.log',
    ],
  }).then((files) =>
    files.map((relativePath) => {
      return {
        path: join(cwd, relativePath),
        relativePath,
      };
    })
  );
}
